import React, {Component} from "react";
import {GoogleOAuthProvider, GoogleLogin} from '@react-oauth/google';
import * as Sentry from "@sentry/browser";

export class LoginWithGoogle extends Component {
    constructor(props) {
        super(props);

        this.responseOnSuccess = this.responseOnSuccess.bind(this);
        this.responseOnFailure = this.responseOnFailure.bind(this);
    }

    // Con `onFailure`, quien monta el botón muestra el error en su pantalla; sin él queda el
    // `alert()` de siempre (la invitación, el portal y Shopify todavía no lo pasan).
    responseOnFailure(response) {
        Sentry.captureException(response);
        if (this.props.onFailure) {
            this.props.onFailure();
        } else {
            alert("There was a problem with the Google login process. Please try again later.");
        }
    }

    responseOnSuccess(credentialResponse) {
        if (credentialResponse.credential) {
            this.props.onGoogleLoginSucessful({
                token_id: credentialResponse.credential,
            });
        } else {
            this.responseOnFailure(credentialResponse);
        }
    }

    render() {
        return (
            <GoogleOAuthProvider clientId="330373907640-iug7bu3cqe277t7faqckn34uu16vts0l.apps.googleusercontent.com">
                <div className="login-buttons mt-5">
                    <GoogleLogin
                        onSuccess={this.responseOnSuccess}
                        onError={this.responseOnFailure}
                        useOneTap
                        locale="es"
                        width={this.props.width}
                        size={this.props.size}
                        text={this.props.text}
                    />
                </div>
            </GoogleOAuthProvider>
            
        );
    }

}
